import { devtools } from 'zustand/middleware';
import type { StateCreator } from 'zustand';
const IS_DEV = process.env.NODE_ENV !== 'production';

export const middlewares = <T>(
    storeName: string,
    fn: StateCreator<T, any, any>
) => {
    return IS_DEV
        ? devtools(fn, { name: storeName, serialize: { options: true } })
        : fn;
};
